import { Plan, PlanMeta } from "../types";

export const PLAN_META: Record<Plan, PlanMeta> = {
    [Plan.Public]: {
        title: "Public Plan",
        description: "For personal work, open source projects, and research.",
        tagline: "For open source",
        icon: "far fa-globe",
        support: "Community Support",
        visibleOnPricingTable: true
    },
    [Plan.UbpBasic]: {
        title: "Basic Plan",
        description:
            "For startups and small teams building their first computer vision application.",
        tagline: "For small teams",
        icon: "far fa-cube",
        support: "Community Support",
        visibleOnPricingTable: false
    },
    [Plan.UbpCore]: {
        title: "Core Plan",
        description: "For individuals and small companies that need private data.",
        tagline: "For individuals",
        icon: "far fa-cube",
        support: "Community Support",
        visibleOnPricingTable: true
    },
    [Plan.UbpGrowth]: {
        title: "Growth Plan",
        description: "For teams looking to build and deploy production models at scale.",
        tagline: "For startups",
        icon: "far fa-cubes",
        support: "Priority Chat and Email Support, Onboarding with Specialists",
        visibleOnPricingTable: false
    },
    [Plan.UbpPremiumTrial]: {
        title: "Premium Trial",
        description:
            "For teams looking to test premium features while building and deploying models.",
        tagline: "For startups",
        icon: "far fa-gift",
        support: "Priority Support",
        visibleOnPricingTable: false
    },
    [Plan.EnterpriseGrowth]: {
        title: "Growth Plan",
        description: "For teams scaling beyond self-serve limits with dedicated support.",
        tagline: "For organizations",
        icon: "far fa-seedling",
        support: "Priority Support",
        visibleOnPricingTable: false
    },
    [Plan.Enterprise]: {
        title: "Enterprise Plan",
        description:
            "For scaled organizations with advanced deployment, security, and control needs.",
        tagline: "For organizations",
        icon: "far fa-building",
        support: "Dedicated Field Engineering Support",
        visibleOnPricingTable: true
    },
    [Plan.LegacySandbox]: {
        title: "Sandbox Plan",
        description: "For personal work, open source projects, and research.",
        tagline: "For open source",
        icon: "far fa-umbrella-beach",
        support: "Community Support",
        visibleOnPricingTable: false
    },
    [Plan.LegacyStarter]: {
        title: "Starter Plan",
        description: "Enjoy premium features, expanded limits, and priority support.",
        tagline: "For premium features",
        icon: "far fa-star",
        support: "Priority Support",
        visibleOnPricingTable: false
    },
    [Plan.Research]: {
        title: "Research Plan",
        description: "For personal work, open source projects, and research.",
        tagline: "For open source",
        icon: "far fa-microscope",
        support: "Community Support",
        visibleOnPricingTable: false
    },
    [Plan.UninitalizedWorkspace]: {
        title: "New Workspace",
        description: "",
        tagline: "",
        icon: "far fa-sparkle",
        support: "",
        visibleOnPricingTable: false
    }
} as any;
